'use client'

import { useState } from 'react'
import { ReassuranceTestimonialsProductCarouselFragment } from './ReassuranceTestimonialsProductCarousel.generated'
import { cn } from '@desoutter/uikit'
import ProductsCarouselCard from '../../ProductsCarouselBlock/ProductsCarouselCard/ProductsCarouselCard'

type ReassuranceTestimonialsProductCarouselProps = {
	fragment: ReassuranceTestimonialsProductCarouselFragment
}
export default function ReassuranceTestimonialsProductCarousel({
	fragment,
}: ReassuranceTestimonialsProductCarouselProps) {
	const [activeProduct, setActiveProduct] = useState(fragment.products[0])

	return (
		<div className={cn('flex flex-col w-full lg:w-1/3 gap-4')}>
			<ProductsCarouselCard
				fragment={activeProduct}
				isDark={fragment.isDark}
				className={'animate-fadeIn h-[420px] items-center'}
			/>
			{fragment.products.length > 1 && (
				<div className="flex w-full gap-2 h-1.5">
					{fragment.products.map((product) => (
						<div
							key={product.id}
							className={cn(
								'h-full w-full cursor-pointer transition-colors duration-1000',
								activeProduct.id === product.id
									? 'bg-primary '
									: 'bg-gray-300 dark:bg-gray-700',
							)}
							onClick={() => setActiveProduct(product)}
						/>
					))}
				</div>
			)}
		</div>
	)
}
